import {AxiosError} from "axios";
import {showLoader} from "@/stores/ui.store.ts";
import {toast} from "sonner";

export function getErrorMessage(error: any) {
  let msg = "";
  console.error(error);
  if (typeof error === "string") {
    msg = error;
  } else if (error instanceof AxiosError) {
    if (error.message) {
      msg = error.message;
    }
    const data = error.response?.data;

    if (typeof data === "object" && (data.message || data.error)) {
      msg = data.error || data.message;
    }
  } else if (typeof error === "object") {
    if (error.message) {
      msg = error.message;
    } else if (error.error) {
      msg = error.error;
    }
  }
  return msg;
}

export function useNotifications() {
  const showError = (error: any) => {
    toast.error(getErrorMessage(error));
  };

  const showInfo = (msg: string) => {
    toast.info(msg)
  };

  const showWarning = (msg: string) => {
    toast.warning(msg);
  };

  const showSuccess = (msg: string) => {
    toast.success(msg);
  };
  // noinspection JSUnusedGlobalSymbols
  const mutateProps = {
    onMutate: () => {
      showLoader(true);
    },
    onError: (error:any) => {
      showError(error);
    },
    onSettled: () => {
      showLoader(false);
    }
  };
  return {showError, showInfo, showSuccess, showWarning, mutateProps};
}